import {
  JYOTISH_PLANETS,
  WESTERN_PLANETS,
  type Planet,
  type PlanetPosition,
} from '@astrally/shared';
import type { EphemerisAdapter } from '../ephemeris/adapter.js';
import { getAyanamsa } from '../ayanamsa/lahiri.js';
import type { AyanamsaId } from '@astrally/shared';
import { norm360 } from '../math/angles.js';
import { nakshatraOf, signPosition } from './zodiac.js';

/** Union of bodies needed for both systems (computed once, used everywhere). */
export const ALL_PLANETS: Planet[] = Array.from(
  new Set<Planet>([...JYOTISH_PLANETS, ...WESTERN_PLANETS]),
);

export function computePositions(
  utc: Date,
  adapter: EphemerisAdapter,
  ayanamsaId: AyanamsaId = 'lahiri',
  planets: Planet[] = ALL_PLANETS,
): PlanetPosition[] {
  const ayan = getAyanamsa(ayanamsaId).valueDeg(adapter.julianCenturiesTT(utc));
  return planets.map((planet) => {
    const st = adapter.position(planet, utc);
    const lonSidereal = norm360(st.lon - ayan);
    // Rahu/Ketu always move retrograde by convention (mean node regresses).
    const retrograde = planet === 'rahu' || planet === 'ketu' ? true : st.speed < 0;
    return {
      planet,
      lonTropical: st.lon,
      lonSidereal,
      latEcliptic: st.lat,
      speed: st.speed,
      retrograde,
      tropical: signPosition(st.lon),
      sidereal: signPosition(lonSidereal),
      nakshatra: nakshatraOf(lonSidereal),
    };
  });
}

export function ayanamsaValue(
  utc: Date,
  adapter: EphemerisAdapter,
  ayanamsaId: AyanamsaId = 'lahiri',
): number {
  return getAyanamsa(ayanamsaId).valueDeg(adapter.julianCenturiesTT(utc));
}
